// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes homeFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.homePage .homeHero {
  position: relative;
  min-height: min(92vh, 820px);
  display: flex;
  align-items: center;
  overflow: hidden;
  background: radial-gradient(ellipse 80% 60% at 85% 20%, rgba(63, 185, 234, 0.22), transparent 55%), radial-gradient(ellipse 50% 40% at 10% 80%, rgba(63, 185, 234, 0.1), transparent 50%), linear-gradient(165deg, #eef5fa 0%, #ffffff 48%, #f7fafc 100%);
}
.homePage .homeHero__atmosphere {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(26, 31, 44, 0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(26, 31, 44, 0.03) 1px, transparent 1px);
  background-size: 48px 48px;
  -webkit-mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 85%);
          mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 85%);
  pointer-events: none;
}
.homePage .homeHero__inner {
  width: min(1120px, 100% - 2.5rem);
  margin-inline: auto;
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1.05fr 0.95fr;
  gap: clamp(2rem, 5vw, 4rem);
  align-items: center;
  padding: clamp(3rem, 8vh, 5.5rem) 0;
}
.homePage .homeHero__brand {
  margin: 0 0 0.85rem;
  font-size: clamp(1.75rem, 3.5vw, 2.65rem);
  font-weight: 700;
  color: #1a1f2c;
  line-height: 1.1;
  animation: homeFadeUp 0.8s ease both;
}
.homePage .homeHero__title {
  margin: 0 0 1.1rem;
  font-size: clamp(1.55rem, 3.2vw, 2.35rem);
  font-weight: 600;
  line-height: 1.2;
  color: #1a1f2c;
  max-width: 16ch;
  animation: homeFadeUp 0.8s ease 0.12s both;
}
.homePage .homeHero__disc {
  margin: 0 0 1.75rem;
  font-size: clamp(1rem, 1.4vw, 1.15rem);
  line-height: 1.65;
  color: #5c6578;
  max-width: 36rem;
  font-weight: 400;
  animation: homeFadeUp 0.8s ease 0.22s both;
}
.homePage .homeHero__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  animation: homeFadeUp 0.8s ease 0.32s both;
}
.homePage .homeHero__visual {
  display: flex;
  justify-content: center;
  align-items: center;
}
.homePage .homeHero__img {
  width: min(100%, 520px);
  height: auto;
  animation: homeFloat 5.5s ease-in-out infinite;
  filter: drop-shadow(0 24px 40px rgba(26, 31, 44, 0.12));
}

@media (max-width: 991px) {
  .homePage .homeHero {
    min-height: auto;
  }
  .homePage .homeHero__inner {
    grid-template-columns: 1fr;
    text-align: left;
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }
  .homePage .homeHero__title {
    max-width: none;
  }
  .homePage .homeHero__visual {
    order: -1;
  }
  .homePage .homeHero__img {
    width: min(100%, 380px);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/Home/home-tokens.scss","webpack://./src/Components/Home/Header/Style.scss"],"names":[],"mappings":"AA2BA;EACE;IACE,UAAA;IACA,2BAAA;EC1BF;ED4BA;IACE,UAAA;IACA,wBAAA;EC1BF;AACF;AD6BA;EACE;IAEE,wBAAA;EC5BF;ED8BA;IACE,4BAAA;EC5BF;AACF;AAfA;EACE,kBAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,yPACE;AAgBJ;AAZE;EACE,kBAAA;EACA,QAAA;EACA,mJACE;EAEF,0BAAA;EACA,oFAAA;UAAA,4EAAA;EACA,oBAAA;AAYJ;AATE;EDZA,iCAAA;EACA,mBAAA;ECaE,kBAAA;EACA,UAAA;EACA,aAAA;EACA,oCAAA;EACA,2BAAA;EACA,mBAAA;EACA,mCAAA;AAYJ;AATE;EACE,mBAAA;EACA,yCAAA;EACA,gBAAA;EACA,cDvCO;ECwCP,gBAAA;EACA,oCAAA;AAWJ;AARE;EACE,kBAAA;EACA,yCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cDjDO;ECkDP,eAAA;EACA,0CAAA;AAUJ;AAPE;EACE,mBAAA;EACA,sCAAA;EACA,iBAAA;EACA,cDzDS;EC0DT,gBAAA;EACA,gBAAA;EACA,0CAAA;AASJ;AANE;EACE,aAAA;EACA,eAAA;EACA,YAAA;EACA,0CAAA;AAQJ;AALE;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;AAOJ;AAJE;EACE,uBAAA;EACA,YAAA;EACA,8CAAA;EACA,uDAAA;AAMJ;;AAFA;EACE;IACE,gBAAA;EAKF;EAHE;IACE,0BAAA;IACA,gBAAA;IACA,mBAAA;IACA,sBAAA;EAKJ;EAFE;IACE,eAAA;EAIJ;EADE;IACE,SAAA;EAGJ;EAAE;IACE,uBAAA;EAEJ;AACF","sourcesContent":["$home-ink: #1a1f2c;\r\n$home-muted: #5c6578;\r\n$home-line: rgba(26, 31, 44, 0.08);\r\n$home-mist: #f4f7fb;\r\n$home-paper: #ffffff;\r\n$home-teal: #3fb9ea;\r\n$home-teal-deep: #1a9fd4;\r\n$home-red: #d60000;\r\n$home-display: \"Plus Jakarta Sans\", system-ui, sans-serif;\r\n$home-body: \"Outfit\", system-ui, sans-serif;\r\n\r\n@mixin home-container {\r\n  width: min(1120px, calc(100% - 2.5rem));\r\n  margin-inline: auto;\r\n}\r\n\r\n@mixin home-reveal {\r\n  opacity: 0;\r\n  transform: translateY(28px);\r\n  transition: opacity 0.7s ease, transform 0.7s ease;\r\n\r\n  &.is-visible {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFadeUp {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(24px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n@keyframes homeFloat {\r\n  0%,\r\n  100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-12px);\r\n  }\r\n}\r\n","@import \"../home-tokens.scss\";\n\n.homePage .homeHero {\n  position: relative;\n  min-height: min(92vh, 820px);\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  background:\n    radial-gradient(ellipse 80% 60% at 85% 20%, rgba(63, 185, 234, 0.22), transparent 55%),\n    radial-gradient(ellipse 50% 40% at 10% 80%, rgba(63, 185, 234, 0.1), transparent 50%),\n    linear-gradient(165deg, #eef5fa 0%, $home-paper 48%, #f7fafc 100%);\n\n  &__atmosphere {\n    position: absolute;\n    inset: 0;\n    background-image:\n      linear-gradient(rgba(26, 31, 44, 0.03) 1px, transparent 1px),\n      linear-gradient(90deg, rgba(26, 31, 44, 0.03) 1px, transparent 1px);\n    background-size: 48px 48px;\n    mask-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.55), transparent 85%);\n    pointer-events: none;\n  }\n\n  &__inner {\n    @include home-container;\n    position: relative;\n    z-index: 1;\n    display: grid;\n    grid-template-columns: 1.05fr 0.95fr;\n    gap: clamp(2rem, 5vw, 4rem);\n    align-items: center;\n    padding: clamp(3rem, 8vh, 5.5rem) 0;\n  }\n\n  &__brand {\n    margin: 0 0 0.85rem;\n    font-size: clamp(1.75rem, 3.5vw, 2.65rem);\n    font-weight: 700;\n    color: $home-ink;\n    line-height: 1.1;\n    animation: homeFadeUp 0.8s ease both;\n  }\n\n  &__title {\n    margin: 0 0 1.1rem;\n    font-size: clamp(1.55rem, 3.2vw, 2.35rem);\n    font-weight: 600;\n    line-height: 1.2;\n    color: $home-ink;\n    max-width: 16ch;\n    animation: homeFadeUp 0.8s ease 0.12s both;\n  }\n\n  &__disc {\n    margin: 0 0 1.75rem;\n    font-size: clamp(1rem, 1.4vw, 1.15rem);\n    line-height: 1.65;\n    color: $home-muted;\n    max-width: 36rem;\n    font-weight: 400;\n    animation: homeFadeUp 0.8s ease 0.22s both;\n  }\n\n  &__actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n    animation: homeFadeUp 0.8s ease 0.32s both;\n  }\n\n  &__visual {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n  }\n\n  &__img {\n    width: min(100%, 520px);\n    height: auto;\n    animation: homeFloat 5.5s ease-in-out infinite;\n    filter: drop-shadow(0 24px 40px rgba(26, 31, 44, 0.12));\n  }\n}\n\n@media (max-width: 991px) {\n  .homePage .homeHero {\n    min-height: auto;\n\n    &__inner {\n      grid-template-columns: 1fr;\n      text-align: left;\n      padding-top: 2.5rem;\n      padding-bottom: 2.5rem;\n    }\n\n    &__title {\n      max-width: none;\n    }\n\n    &__visual {\n      order: -1;\n    }\n\n    &__img {\n      width: min(100%, 380px);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
